export const VALIDATE_IS_NOT_ALLOWED = 'VALIDATE_IS_NOT_ALLOWED';
export const VALIDATE_IS_NOT_RECOMMENDED = 'VALIDATE_IS_NOT_RECOMMENDED';
export const VALIDATE_IS_PENDING = 'VALIDATE_IS_PENDING';
